<vc-badge
    [prefixIcon]="statusIcon"
    [label]="severity | textRenderer: severityRenderer"
    [status]="badgeStatus"
    [tooltip]="severity | textRenderer: severityRenderer"
    [tooltipPosition]="tooltipPosition"
    [showTooltip]="showTooltip"></vc-badge>
